export default __webpack_public_path__ + "static/media/myMemiii-Logo.8d90c4ef.png";